import { ConfigInterface } from './types';

const defaultConfig: ConfigInterface = {
  suffix: 'testid',
  enableInProductionMode: false,
};

export default defaultConfig;
